import { ActionType } from "../types";
import { Session, SessionAction } from "../types/session";

export const session = (
  state: Session = null,
  action: SessionAction
): Session => {
  switch (action.type) {
    case ActionType.GET_SESSION_SUCCESS:
      return {
        ...state,
        ...action.data,
      };
    case ActionType.GET_SESSION_FAILURE:
      return null;
    default:
      return state;
  }
};
